import React, { ReactNode } from 'react';
import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Typography,
} from '@mui/material';
import {
  Cloud,
  Code,
  Hub,
  Outlet,
  Router,
  SolarPower,
  Subscriptions,
  Timeline,
} from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import { To, useNavigate } from 'react-router-dom';

import { Group } from '../../organisms/group';
import { ServiceAccessInput } from '../../organisms/settings/service-access-input';
import { useSelector } from '../../store/utils';

const items: (
  | {
      icon?: ReactNode;
      label: ReactNode;
      subLabel?: ReactNode;
      to: To;
    }
  | { divider: true }
)[] = [
  { icon: <Router />, label: 'Network', to: '/dev/network' },
  { divider: true },
  {
    icon: <Cloud />,
    label: 'MQTT Cloud',
    subLabel: 'Zásuvky pro BD, komunity',
    to: '/dev/mqtt-cloud',
  },
  {
    icon: <Hub />,
    label: 'MQTT Broker',
    subLabel: 'Lokální MQTT (např. elektroměry)',
    to: '/dev/mqtt-broker',
  },
  {
    icon: <Outlet />,
    label: 'Shellies',
    subLabel: 'Lokální Shelly (např. elektroměry)',
    to: '/dev/shellies',
  },
  {
    icon: <Router />,
    label: 'AZ routery',
    to: '/dev/az-routers',
  },
  {
    icon: <Outlet />,
    label: 'Cloudové zásuvky',
    subLabel: '',
    to: '/dev/zasuvky-cloud',
  },
  {
    icon: <SolarPower />,
    label: 'Konfigurace střídačů',
    subLabel: 'Více střídačů, INVERTER_CONFIG',
    to: '/dev/konfigurace-stridacu',
  },
  { divider: true },
  { icon: <Code />, label: 'Scripty', to: '/dev/scripts' },
  {
    icon: <Timeline />,
    label: 'Status log',
    subLabel: 'Historie stavů (control mode, PV status)',
    to: '/dev/status-log',
  },
  { divider: true },
  { label: 'Delta Green', to: '/dev/delta-green' },
  { label: 'Electree', to: '/dev/electree' },
  { label: 'Energomachine', to: '/dev/energomachine' },
  { label: 'bezDodavatele', to: '/dev/bez-dodavatele' },
  { label: 'PRE Flexibilita', to: '/dev/pre-flexibility' },
  {
    label: 'Enerco',
    subLabel: 'Predikce komunity (EAN)',
    to: '/dev/enerco',
  },
  { divider: true },
  { label: 'Předplatné', to: '/dev/predplatne', icon: <Subscriptions /> },
  { label: 'Notifikace', to: '/dev/zpravy' },
  { divider: true },
  { label: 'EMS', to: '/ems-service' },
];

const DevHomepage = () => {
  const [serviceActive] = useSelector(
    ({ variables }) => [variables.SERVICE_ACTIVE] as const
  );

  const navigate = useNavigate();

  if (!serviceActive) {
    return (
      <Group
        layout="list"
        title={
          <FormattedMessage
            id="dev_homepage.title"
            defaultMessage="Vývojové menu"
          />
        }
      >
        <ServiceAccessInput />
      </Group>
    );
  }

  return (
    <Group
      layout="list"
      title={
        <FormattedMessage
          id="dev_homepage.title"
          defaultMessage="Vývojové menu"
        />
      }
    >
      <Paper>
        <Box sx={{ width: 600 }}>
          <MenuList>
            {items.map((item, i) => {
              if ('divider' in item) {
                return <Divider key={i} />;
              }

              const { icon, label, subLabel } = item;

              return (
                <MenuItem key={i} onClick={() => navigate(item.to)}>
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText>{label}</ListItemText>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {subLabel}
                  </Typography>
                </MenuItem>
              );
            })}
          </MenuList>
        </Box>
      </Paper>
    </Group>
  );
};

export default DevHomepage;
